import type { ToastMessage } from '../game/useGame';

export interface ToastProps {
  toast: ToastMessage | null;
}

/** Transient status line. Keyed by id so repeats re-announce and re-animate. */
export function Toast({ toast }: ToastProps) {
  if (!toast) return null;
  return (
    <div className="pointer-events-none absolute inset-x-0 top-1 z-30 flex justify-center">
      <div key={toast.id} role="alert" className="toast">
        {toast.text}
      </div>
    </div>
  );
}
